<template>
    <v-btn
            color="secondary"
            outline
            :disabled="disabled"
            @click="$store.commit('stepper/previousStep')"
    >
        Zurück
    </v-btn>
</template>

<script>
    export default {
        name: "ButtonPrevious",
        props: {
            disabled: {
                type: Boolean,
                default: false,
            }
        }
    }
</script>

<style scoped>

</style>
